var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.currentLabel)+":  ")]),_c('div',{staticClass:"activator",on:{"click":_vm.onActivatorClick}},[_vm._v(" "+_vm._s(_vm.selectedValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }